export const LISTING_PREVIEW_VARIANT = 'listing-preview';
export const LISTING_PREVIEW_VARIANT_2X = 'listing-preview-2x';
export const LISTING_VIEWER_VARIANT = 'listing-viewer';

export const LISTING_PREVIEW_VARIANTS = [LISTING_PREVIEW_VARIANT, LISTING_PREVIEW_VARIANT_2X];

export const LISTING_VIEWER_VARIANTS = [
  LISTING_VIEWER_VARIANT,
  LISTING_PREVIEW_VARIANT_2X,
  LISTING_PREVIEW_VARIANT,
  'default',
];

const getImageVariants = image => image?.attributes?.variants || {};

const getLargestVariant = variants => {
  return Object.values(variants)
    .filter(variant => variant?.url)
    .sort((left, right) => (right?.width || 0) - (left?.width || 0))[0];
};

export const getFirstAvailableVariant = (image, variantNames = []) => {
  const variants = getImageVariants(image);
  const orderedVariantNames = Array.isArray(variantNames) ? variantNames : [];
  const matchingVariantName = orderedVariantNames.find(variantName => variants?.[variantName]?.url);

  if (matchingVariantName) {
    return variants[matchingVariantName];
  }

  if (variants.default?.url) {
    return variants.default;
  }

  return getLargestVariant(variants);
};

export const getViewerImage = (image, alt, variantNames = LISTING_VIEWER_VARIANTS) => {
  const variants = getImageVariants(image);
  const candidates = Object.entries(variants).filter(([, variant]) => variant?.url);
  // The API returns signed URLs. Inspect their fit mode, but never rewrite them.
  // In particular, scaled-xlarge can be overridden with fit:crop by card queries.
  const uncropped = candidates.filter(([name, variant]) => {
    try {
      const fit = new URL(variant.url).searchParams.get('fit');
      if (fit) {
        return fit === 'clip' || fit === 'scale' || fit === 'max';
      }
    } catch (e) {
      // Relative fixture/legacy URLs can still use the known variant names.
    }
    return !/crop|listing-card|square-|facebook|twitter/.test(name);
  });
  const preferredNames = Array.isArray(variantNames) ? variantNames : [];
  const ranked = (uncropped.length ? uncropped : candidates).sort(([nameA, a], [nameB, b]) => {
    const areaDifference = (b.width || 0) * (b.height || 0) - (a.width || 0) * (a.height || 0);
    // Preference is only a tie-breaker: a gallery/default variant must never
    // win over an available larger, uncropped asset.
    return (
      areaDifference ||
      Number(preferredNames.includes(nameB)) - Number(preferredNames.includes(nameA))
    );
  });
  const variant = variants.original?.url ? variants.original : ranked[0]?.[1];
  const src = variant?.url || '';

  // Let react-viewer size the decoded image. API dimensions can disagree with
  // the oriented asset, and defaultSize overrides the loaded image's aspect ratio.
  return {
    src,
    alt,
    downloadUrl: src,
  };
};
